import { render, staticRenderFns } from "./InterventionReassignEmployeModal.vue?vue&type=template&id=2fbf8f56"
import script from "./InterventionReassignEmployeModal.vue?vue&type=script&lang=ts"
export * from "./InterventionReassignEmployeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports